import { render, staticRenderFns } from "./BeforeTripListAdd.vue?vue&type=template&id=6c0b83ba"
import script from "./BeforeTripListAdd.vue?vue&type=script&lang=js"
export * from "./BeforeTripListAdd.vue?vue&type=script&lang=js"
import style0 from "./BeforeTripListAdd.vue?vue&type=style&index=0&id=6c0b83ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports